<template>
  <div>
    <v-alert
      v-if="
        $store.state.user.documentacion == 'Si' &&
        $store.state.user.estado == 'Pendiente'
      "
      type="warning"
    >
      {{ $t("documentacion_pendiente") }}
    </v-alert>
    <v-row v-if="!$store.state.user.origen_id">
      <v-col cols="4">
        <v-select
          item-text="nombre"
          item-value="id"
          label="Origen"
          :items="origins"
          v-model="form.origen_id"
          @change="getDocuments"
        />
      </v-col>
    </v-row>
    <v-row v-show="form.origen_id && ($store.state.user.estado === 'Pendiente' &&
            $store.state.user.documentacion !== 'Si') ||
            $store.state.user.estado !== 'Pendiente'">
      <v-col cols="4" v-for="doc in docs" :key="doc.id">
        <v-file-input
          :label="doc[`nombre_${$root.$i18n.locale}`]"
          accept="application/pdf"
          v-model="providerDocs[doc.id]"
        />
      </v-col>
    </v-row>
    <v-fab-transition>
      <v-btn
        v-if="($store.state.user.estado === 'Pendiente' &&
            $store.state.user.documentacion !== 'Si') ||
            $store.state.user.estado !== 'Pendiente'"
        fab
        fixed
        bottom
        right
        color="blue"
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
export default {
  name: "Documentacion",
  data() {
    return {
      form: {},
      origins: [],
      docs: [],
      providerDocs: [],
    };
  },
  mounted() {
    if (!this.$store.state.user.origen_id) {
      this.getOrigins();
    } else {
      this.form.origen_id = this.$store.state.user.origen_id;
      this.getDocuments();
    }
  },
  methods: {
    async getOrigins() {
      this.openLoader();
      const generalDocURL = `${this.$store.state.proveedorUrl}catalogos/documentacion`;
      const generalDocParams = { idioma: this.$root.$i18n.locale };
      const { data } = await this.sendRequest(generalDocURL, generalDocParams);
      this.origins = data;
      this.closeLoader();
    },
    async getDocuments() {
      this.openLoader();
      const originDocURL = `${this.$store.state.proveedorUrl}catalogos/documentacion/${this.form.origen_id}/documentos`;
      const originDocParams = { idioma: this.$root.$i18n.locale };
      const { data } = await this.sendRequest(originDocURL, originDocParams);
      this.docs = data;
      this.closeLoader();
    },
    async save() {
      this.openLoader();
      const registerURL = `${this.$store.state.proveedorUrl}documentacion/${this.$store.state.user.id}`;

      let form = new FormData();
      Object.keys(this.form).map((k) => form.append(k, this.form[k]));
      if (Object.keys(this.providerDocs).length) {
        Object.keys(this.providerDocs).map((k) => {
          form.append(`docs[${k}]`, this.providerDocs[k]);
        });
      }
      form.append("_method", "PUT");

      const registerRequest = await this.sendRequest(
        registerURL,
        form,
        "POST",
        true
      );
      if (registerRequest.success) {
        this.showSuccessMessage(registerRequest.message);

        const userURL = `${this.$store.state.proveedorUrl}${this.$store.state.user.id}`;
        const { data } = await this.sendRequest(userURL);
        this.$store.state.user = data;
        window.localStorage.user = JSON.stringify(data);

        window.location.reload();
      }
      this.closeLoader();
    },
  },
};
</script>